import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Input, QueryList } from '@angular/core';
import { lastValueFrom } from '../../helpers/functions.helpers';
import { getValueProperty, setValueProperty } from '../../helpers/functions.helpers';
import { ApplicationService } from '../application/application.service';
import { LinkupService } from '../link-up/linkup.service';
import { TokenService } from '../security/token.service';
import { merge } from 'lodash';

export class ClientNotFoundException implements Error{
  readonly name = 'ClientNotFoundException';
  readonly message = 'No es posible encontrar el usuario indicado';
}

export class RiskLevelNotFoundException implements Error{
  readonly name = 'RiskLevelNotFoundException';
  readonly message = 'No es posible encontrar los datos de nivel de riesgo del usuario indicado';
}

export class RiskLevelErrorService implements Error{
  readonly name = 'RiskLevelErrorService';
  readonly message = 'Error en servicio de nivel de riesgo.';
}



@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  @Input()lenght:any;
  listado: QueryList<any>|any;

  constructor(
    private _http: HttpClient,
    private _link: LinkupService,
    private _token: TokenService,
    readonly _app: ApplicationService
  ) { }

  /**
   *
   * @param documentNumber
   * @param documentType
   * @returns
   */
  async find(documentNumber: string | number, documentType: string | number) {
    const contextUrls = await this._link.contextUrls;
    let client = `${documentNumber}_${documentType}`;
    const URL = `${contextUrls.URLS.CLIENTS_V1}${client}/details`;
    let httpOptions: any = await this.httpOptions();
    const req$ = this._http.get(URL, httpOptions);
    const response: any = await lastValueFrom(req$)
      .catch((error: HttpErrorResponse) => {
        if(error.status === 422){
          throw new ClientNotFoundException();
        }else{
          throw new Error("Error en servicio");
        }
      });
      let responseClean = response;
      try {

        if (responseClean && responseClean.hasOwnProperty('data')) {
          setValueProperty(
            responseClean,
            'data.client_name',
            `${getValueProperty(responseClean, 'data.client_name', '')}`,
            true
          );

          let familyNames: Array<string> = getValueProperty(responseClean, 'data.family_names', []);
          let givenNames: Array<string> = getValueProperty(responseClean, 'data.given_names', []);

          familyNames = familyNames.filter((item)=>{
            return this.isEmpty(item);
          }).map((x:any)=>{return x.substring(0,this.lenght).trim()});

          givenNames = givenNames.filter((item)=>{
            return this.isEmpty(item);
          }).map((x:any)=>{return x.substring(0,this.lenght).trim()});
          setValueProperty(responseClean, 'data.family_names',familyNames, true);
          let resposeData = getValueProperty(responseClean, "data", {});
          if(this._app.currentApplication == 'digitalSolicitations')Object.defineProperty(resposeData,'SA_Names',{value:'Comercial Especializado'});

          return responseClean['data'];
        } else {
          setValueProperty(
            responseClean,
            'client_name',
            `${getValueProperty(responseClean, 'client_name', '')}`,
            true
          );

          let familyNames: Array<string> = getValueProperty(responseClean, 'family_names', []);
          let givenNames: Array<string> = getValueProperty(responseClean, 'given_names', []);

          familyNames = familyNames.filter((item)=>{
            return this.isEmpty(item);
          });

          givenNames = givenNames.filter((item)=>{
            return this.isEmpty(item);
          });

          setValueProperty(responseClean, 'family_names',familyNames, true);
          setValueProperty(responseClean, 'given_names',givenNames, true);
          let resposeData = getValueProperty(responseClean, "data", {});
          if(this._app.currentApplication == 'digitalSolicitations')Object.defineProperty(resposeData,'SA_Names',{value:'Comercial Especializado'});

          return responseClean;
        };

      } catch (error) {
        return responseClean;
      }
  }
  /*
  /// ->  ACTUALIZACIÓN DE RESULTADOS DE CONSULTA DE CLIENTES
  /// ->  INCLUSIÓN DEL CAMPO: NOMBRE DEL ASESOR ESPECIALIZADO EN CANAL PORTAL OPERADOR [PPG327PP-3841]
  /// ->  CONTENIDO AGREGADO LN 74 Y LN 99
  /// ->  OM03560 - 23-11-2022
  */

  /**
   * Permite consultar el nivel de riesgo de un cliente
   */
  async findRiskNvl(documentNumber: string | number, documentType: string | number) {
    const contextUrls = await this._link.contextUrls;
    let client = `${documentNumber}_${documentType}`;
    const URL = `${contextUrls.URLS.RISK_NVL}update/status`;
    let httpOptions: any = await this.httpOptions();
    httpOptions.headers["token-client-id"] = client;
    httpOptions.headers["serviceCode"] = "CUS-07501";
    //httpOptions.headers["application"] = "Operador Portal";
    httpOptions.headers["channel-id"] = this._app.channelId;
    const req$ = this._http.get(URL, httpOptions);
    const response: any = await lastValueFrom(req$)
      .catch((error: HttpErrorResponse) => {
        throw new RiskLevelErrorService();        
      });
    if (response && response.hasOwnProperty('data')) {
      return response['data'];
    } else {
      return response;
    };
  }

  async findclientfiducial(documentNumber: string | number, documentType: string | number) {

    if(documentNumber == "111111") {
      return {
        "action": "Error",
        "message":"Error al consultar el cliente"
      };
    }
    else if(documentNumber == "222222") {
      return {
        "action": "Not_Found",
        "message":"Cliente no encontrado"
      };
    }
    else{
      let data = {
        "basicData": {
          "document_type": documentType,
          "document_number": documentNumber
        }
      };
      const linksettings = await this._link.settings;
      const currentApplication = getValueProperty(this._app, "currentApplication", "fiducial");
      let data_settings = getValueProperty(linksettings, `request.FIDUCIAL_FIND.${currentApplication}.default_data`, {});
      return merge(data_settings, data);
    }
  }

  /**
   * Permite construir de manera dinamica los encabezados para las peticiones al catalog manager
   */
  async httpOptions() {
    const { accessToken, tokenType } = await this._token.accessToken;
    const transaction_id = await this._token.transactionId;
    const channelId =  this._app.channelId;
    const channelName = this._app.channelName;
    const sessionId = await this._token.sessionId;

    return {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "application": channelName,
        //"channel-id": channelId,
        "channel_id": channelId,
        "timestamp": new Date().toISOString(),
        "transaction_id": transaction_id,
        "session_id": sessionId,
        "terminal_id": "127.0.0.1"
      }
    };
  }

  isEmpty(item:string){
    return item ? `${item}`.trim().length > 0 : false;
  }
}
